import React from 'react';


export const CheckIcon = props => (
  <svg
    {...props}
    x="0px"
    y="0px"
    viewBox="0 0 70 70"
    stroke="none"
  >
    <path
      d="M26.474,70c-2.176,0-4.234-1.018-5.557-2.764L3.049,43.639C0.725,40.57,1.33,36.2,4.399,33.875
c3.074-2.326,7.441-1.717,9.766,1.35l11.752,15.518L55.474,3.285c2.035-3.265,6.332-4.264,9.604-2.232
c3.268,2.034,4.266,6.334,2.23,9.602l-34.916,56.06c-1.213,1.949-3.307,3.175-5.6,3.279C26.685,69.998,26.58,70,26.474,70z"
    />
  </svg>
);
